// extracted by mini-css-extract-plugin
module.exports = {"language":"e9","languageItem":"fa","active":"fb"};